import FillButton from '@components/Buttons/Fill';
import styled from '@emotion/styled';

export const EnterButton = styled(FillButton)`
  width: 173px;
  height: 54px;
  font-size: 17px;
  border-radius: 3px;
  background: #313463;
  color: white;
  transition: all ease 1s 0s;
  justify-content: center;
  margin: 0 auto;
`;
